import React from 'react';
import Skeleton from 'react-loading-skeleton';

const renderSkeletons = (
  skeletons: {
    width: number | string;
    height: number;
    baseColor: string;
    borderRadius: number;
    className?: string;
    style?: React.CSSProperties;
  }[]
) =>
  skeletons.map((skeleton, index) => (
    <Skeleton
      key={index}
      width={skeleton.width}
      height={skeleton.height}
      baseColor={skeleton.baseColor}
      borderRadius={skeleton.borderRadius}
      className={skeleton.className || ''}
      style={skeleton.style || {}}
    />
  ));

export default renderSkeletons;
